import type { Lead } from './types';
export type LocationState = Pick<Lead, 'location_status' | 'location_attempted_at' | 'coordinate_at' | 'coordinate_source'>;
export const locationMessage = (lead: Partial<LocationState>, now = Date.now()): string => {
  switch (lead.location_status) {
    case 'resolved': return lead.coordinate_source !== 'manual' && lead.coordinate_at && now - Date.parse(lead.coordinate_at) > 90 * 86_400_000
      ? 'Review this location — last confirmed over 90 days ago' : 'Location confirmed';
    case 'resolving': return !lead.location_attempted_at || now - Date.parse(lead.location_attempted_at) >= 120_000
      ? 'Lookup interrupted — Retry' : 'Saved; looking up location';
    case 'needs_review': return 'Confirm this business location';
    case 'no_match': return 'No location found — correct the address, place manually or Retry';
    case 'temporary_error': return 'Saved; location lookup incomplete';
    default: return 'Add street, city and ZIP';
  }
};
export const durablePoint = (lead: Partial<Pick<Lead, 'location_status' | 'coordinate_source' | 'lat' | 'lng'>>) =>
  lead.location_status === 'resolved' && ['census', 'public_roster', 'manual'].includes(lead.coordinate_source ?? '') &&
  typeof lead.lat === 'number' && Number.isFinite(lead.lat) && Math.abs(lead.lat) <= 90 &&
  typeof lead.lng === 'number' && Number.isFinite(lead.lng) && Math.abs(lead.lng) <= 180
    ? { lat: lead.lat, lng: lead.lng } : null;
